import Column from '@components/Column';
import Text from '@components/Text';
import TextField from '@components/TextField';
import colors from '@constants/colors';
import GiftOrderContext from '@providers/GiftOrderProvider/GiftOrderContext';
import { useContext } from 'react';

function Message() {
  const { handleChange } = useContext(GiftOrderContext);
  return (
        <Column fullWidth spacing={12}>
            <Text color={colors.gray7} fontWeight='bold' size='2xl'>
                메시지 입력
            </Text>
            <TextField placeholder='메시지를 입력해주세요.'
                       onChange={handleChange}
                       as='textarea'
                       name='message'
                       rows={3}
                       maxLength={100}
                       showLength />
        </Column>
  );
}

export default Message;
